import React, { useState, useEffect } from 'react';

import './index.css';

const Journals = () => {
    const URL = `${process.env.PUBLIC_URL}/data/preprints.json`;

    const [content, setContent] = useState([]);

    useEffect(() => {
        // GET QuickLinks
        fetch(URL)
            .then((res) => res.json())
            .then((reply) => {
                setContent(reply);
            });
    }, []);

    return (
        <div id="PrePrints" className="preprints">
            <h3>Pre-Prints</h3>
            <ol>
                {content.map((item, index) => {
                    return (
                        <li key={index}>
                            <h5>
                                <a className="preprint-title" target="blank" href={item.link}>
                                    {item.title}
                                </a>
                            </h5>
                            <span className="preprint-author">
                                <i className="fas fa-user-friends" />
                                &nbsp;
                                {item.authors.map((author, authorIndex, arr) => {
                                    const hAuthor =
                                        author === 'Arnab Mukherjee' ? <b>{author}</b> : author;
                                    if (authorIndex === 0) return hAuthor;
                                    if (authorIndex === arr.length - 1)
                                        return <span>&nbsp;&&nbsp;{hAuthor}</span>;
                                    return <span>,&nbsp;{hAuthor}</span>;
                                })}
                            </span>
                            <br />
                            <span className="preprint-name">
                                <i className="fas fa-newspaper" />
                                &nbsp;&nbsp;&nbsp;
                                {item.preprint}
                            </span>
                            &nbsp;&nbsp;&bull;&nbsp;&nbsp;
                            {item.year && item.year > 0 ? (
                                <span>
                                    <span className="preprint-year">{item.year}</span>
                                </span>
                            ) : (
                                ''
                            )}
                            &nbsp;
                            <span className="preprint-status">
                                {item.status.length > 0 ? `(${item.status})` : ''}
                            </span>
                        </li>
                    );
                })}
            </ol>
        </div>
    );
};

export default Journals;
